// Licensing Promo Banners — Swiper init (pattern matches how-it-works-steps.js)
function initSingleLicensingPromoSlider(sliderContainer) {
  if (!sliderContainer) return;

  if (typeof Swiper === "undefined") {
    if (document.readyState === "complete") {
      setTimeout(() => initSingleLicensingPromoSlider(sliderContainer), 200);
    } else {
      window.addEventListener("load", () => initSingleLicensingPromoSlider(sliderContainer), { once: true });
    }
    return;
  }

  const slides = sliderContainer.querySelectorAll(".swiper-slide");
  const totalSlides = slides.length;
  if (!totalSlides) return;

  // Read data attributes from the swiper element itself
  const isAutoplay = sliderContainer.dataset.autoplay === "true";
  const autoplaySpeed = parseInt(sliderContainer.dataset.speed) || 3000;
  const gap = Number(sliderContainer.dataset.gap) || 24;
  const desktopSlides = Math.min(Number(sliderContainer.dataset.desktop) || 2, totalSlides);
  const tabletSlides = Math.min(Number(sliderContainer.dataset.tablet) || 2, totalSlides);
  const mobileSlides = Math.min(Number(sliderContainer.dataset.mobile) || 1, totalSlides);

  const parentSection =
    sliderContainer.closest(".lpb-swiper-outer") || document;
  const nextEl = parentSection.querySelector(".lpb-next");
  const prevEl = parentSection.querySelector(".lpb-prev");

  // Prevent text selection on arrow click — guard against duplicate listeners
  [nextEl, prevEl].forEach((btn) => {
    if (!btn) return;
    if (!btn.dataset.mousedownBound) {
      btn.dataset.mousedownBound = "true";
      btn.addEventListener("mousedown", (e) => e.preventDefault());
    }
    if (btn.dataset.keyboardBound) return;
    btn.dataset.keyboardBound = "true";
    btn.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      if (btn.getAttribute("aria-disabled") !== "true") btn.click();
    });
  });

  if (sliderContainer.swiper) {
    sliderContainer.swiper.destroy(true, true);
  }

  // autoplay ON  => continuous loop, arrows always enabled
  // autoplay OFF => arrows disable at first/last slide, no looping
  const shouldLoop = isAutoplay && totalSlides > 1;

  // Hide arrows when not needed in manual mode
  const shouldHideArrows = !isAutoplay && totalSlides <= desktopSlides;
  if (shouldHideArrows && nextEl) nextEl.style.display = "none";
  if (shouldHideArrows && prevEl) prevEl.style.display = "none";

  function updateArrows(swiper) {
    if (!prevEl || !nextEl) return;
    if (isAutoplay) {
      prevEl.classList.remove("lpb-arrow--disabled");
      nextEl.classList.remove("lpb-arrow--disabled");
      prevEl.setAttribute("aria-disabled", "false");
      nextEl.setAttribute("aria-disabled", "false");
    } else {
      prevEl.classList.toggle("lpb-arrow--disabled", swiper.isBeginning);
      nextEl.classList.toggle("lpb-arrow--disabled", swiper.isEnd);
      prevEl.setAttribute("aria-disabled", swiper.isBeginning ? "true" : "false");
      nextEl.setAttribute("aria-disabled", swiper.isEnd ? "true" : "false");
    }
  }

  const swiperInstance = new Swiper(sliderContainer, {
    slidesPerView: mobileSlides,
    spaceBetween: gap,
    loop: shouldLoop,
    rewind: false,
    watchOverflow: false,
    observer: true,
    observeParents: true,
    speed: 600,
    autoplay: isAutoplay && totalSlides > 1
      ? { delay: autoplaySpeed, disableOnInteraction: false }
      : false,
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl,
      disabledClass: "lpb-arrow--disabled",
    },
    breakpoints: {
      0:   { slidesPerView: mobileSlides,  spaceBetween: 16 },
      576: { slidesPerView: tabletSlides,  spaceBetween: gap },
      992: { slidesPerView: desktopSlides, spaceBetween: gap },
    },
    on: {
      init: updateArrows,
      slideChange: updateArrows,
      reachBeginning: updateArrows,
      reachEnd: updateArrows,
      resize: updateArrows,
    },
  });

  if (isAutoplay && totalSlides > 1 && swiperInstance.autoplay) {
    swiperInstance.autoplay.start();
  }

  setTimeout(() => {
    swiperInstance.update();
    updateArrows(swiperInstance);
  }, 100);
}

function initLicensingPromoSlider() {
  const sliderContainers = document.querySelectorAll(".lpb-swiper");
  sliderContainers.forEach(initSingleLicensingPromoSlider);
}

function setupLicensingPromoObserver() {
  const sliderContainers = document.querySelectorAll(".lpb-swiper");
  if (!sliderContainers.length) return;

  if (!("IntersectionObserver" in window) || (window.Shopify && window.Shopify.designMode)) {
    initLicensingPromoSlider();
    return;
  }

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        obs.unobserve(entry.target);
        initSingleLicensingPromoSlider(entry.target);
      }
    });
  }, { rootMargin: "350px 0px" });

  sliderContainers.forEach((container) => observer.observe(container));
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", setupLicensingPromoObserver);
} else {
  setupLicensingPromoObserver();
}
document.addEventListener("shopify:section:load", initLicensingPromoSlider);
document.addEventListener("shopify:section:select", initLicensingPromoSlider);
